import { render, staticRenderFns } from "./SafetyList.vue?vue&type=template&id=0d47bf98&scoped=true"
import script from "./SafetyList.vue?vue&type=script&lang=js"
export * from "./SafetyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47bf98",
  null
  
)

export default component.exports